import { render, staticRenderFns } from "./imgCode.vue?vue&type=template&id=9c7604b6"
import script from "./imgCode.vue?vue&type=script&lang=js"
export * from "./imgCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports